import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL, Group } from '@edl-development/edl-common';

@Injectable()
export class GroupApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    createGroup(group: Group) {
        return this.http.post(this.baseUri + '/Group', group);
    }

    getGroupsByPortal(portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, baseUrl?: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy));

        return this.http.get(this.baseUri + '/Groups/Portal/' + portalId.toString(), {
            params
        });
    }

    updateGroup(group: Group) {
        return this.http.put(this.baseUri + '/Group', group);
    }

    deleteGroup(group: Group) {
        return this.http.request('delete', this.baseUri + '/Group', {
            responseType: 'text',
            body: group
        });
    }

    restoreGroup(group: Group) {
        return this.http.put(this.baseUri + '/Group/Restore', group, { responseType: 'text' });
    }

    removeGroup(group: Group) {
        return this.http.request('delete', this.baseUri + '/Group/Remove', {
            responseType: 'text',
            body: group
        });
    }

    getGroupByGroupId(groupId: number) {
        return this.http.get(this.baseUri + '/Group/' + groupId.toString());
    }

    getAllGroupsForPortal(){
        return this.http.get(this.baseUri + '/Groups');
    }

    getUserGroupsByPortal(offset: number, limit: number, searchBy: string, role: string, group: string, building: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('searchBy', this.convertParam(searchBy))
            .append('role', this.convertParam(role))
            .append('group', this.convertParam(group))
            .append('building', this.convertParam(building));

        return this.http.get(this.baseUri + '/Groups/UserGroups', {
            params
        });
    }

    saveGroupAssignment(GroupID: string, UserId: any, selected: boolean): any {
        return this.http.put(this.baseUri + '/Group/Assignment/Update', {GroupID, UserId, selected}, { responseType: 'text' });
    }

    uploadUsersForGroup(fileList: FileList, groupName:string, groupId: string){
        let file: File = fileList[0];
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('GroupName', groupName);
        formData.append('GroupID', groupId);

        return this.http.post(this.baseUri + '/Group/UploadUsers', formData);
    }
}